import React, { useState, useEffect } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Button, InputAdornment } from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";
import axios from 'axios';
import { useAuth } from '../../AuthContext';
import Stack from '@mui/material/Stack';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const NewProductForm = ({ isOpen, onClose, selectedRowData }) => {
  const [productName, setProductName] = useState('');
  const [rate, setRate] = useState('');
  const [currentStock, setCurrentStock] = useState('');
  const [allItemsData, setAllItemsData] = useState([]);
  const [quantity, setQuantity] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [list, setList] = useState([]);
  const [id, setID] = useState("");
  const [editMode, setEditMode] = useState(false)
  const [AddToStock, setAddToStock] = useState('0');
  const [category, setCategory] = useState('');
  const [catId, setCatId] = useState('');
  const [categoryData, setCategoryData] = useState([]);

  const { userRole } = useAuth()
  const [employee, setEmployee] = useState(true);

  // UOM declaration

  const [uoms, setUOMs] = useState([{ title: '', value: '', price: '' }]);

  const handleUOMChange = (index, key, newValue) => {
    const updatedUOMs = [...uoms];
    updatedUOMs[index][key] = newValue;
    setUOMs(updatedUOMs);
  };

  const handleAddUOM = () => {
    setUOMs([...uoms, { title: '', value: '', price: '' }]);
  };

  const handleRemoveUOM = (index) => {
    const updatedUOMs = [...uoms];
    updatedUOMs.splice(index, 1);
    setUOMs(updatedUOMs);
  };

  useEffect(() => {
    if (userRole === "manager") {
      setEmployee(false)
    } else {
      setEmployee(true)
    };
  }, [userRole])


  const postData = async () => {
    try {
      if (!productName) {
        console.log("EMPTY FIELD");
      } else {
        console.log(catId, category)
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/products/add_product`, {
          "product_name": productName,
          "product_quantity": currentStock,
          "product_rate": rate,
          "items": list,
          "UOM": uoms,
          "categoryid": catId,
          "categoryname": category
        });
        if (response.status === 200) {
          toast.success(`Product created successfully.`)
        }
      }
    } catch (error) { toast.error("Error creating product") }
  };

  const updateData = async () => {
    if (!productName || !rate || !currentStock) {
      console.log("EMPTY FIELD");
    } else {
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/products/edit_product`, {
        "id": selectedRowData.id,
        "product_name": productName,
        "product_quantity": parseInt(currentStock) + parseInt(AddToStock),
        "product_rate": rate,
        "categoryid": catId,
        "categoryname": category
      });
      if (response.status === 200) {
        toast.success(`Product updated successfully.`)
      }
    }
  };


  useEffect(() => {
    const fetchAllItems = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/itemservices/all_itemservices`);
        const responseData = await response.json();
        if (responseData) {
          const itemData = responseData.itemservice.filter(item => item.type === "Item");
          setAllItemsData(itemData);
        }
      } catch (error) {
        // Handle errors here
        console.error("Error fetching data:", error);
      }
    }
    const fetchAllCategories = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/category/all_categories`);
        const responseData = await response.json();
        if (responseData) {
          setCategoryData(responseData.categories)
        }
      } catch (error) {
        // Handle errors here
        console.error("Error fetching data:", error);
      }
    }
    fetchAllCategories()
    fetchAllItems();

    if (selectedRowData) {
      setProductName(selectedRowData.product_name);
      setCurrentStock(selectedRowData.product_quantity);
      setRate(selectedRowData.product_rate);
      setEditMode(true)
    } else {
      // If no row is selected, clear the form fields
      setProductName('');
      setCurrentStock('');
      setRate('');
    }
  }, [selectedRowData]);

  useEffect(() => {
    if (selectedItem) {
      const selectedItemData = allItemsData.find(
        (item) => item.itemservice === selectedItem
      );
      if (selectedItemData) {
        setID(selectedItemData.id)
      }
    }
  }, [selectedItem, quantity, allItemsData]);

  const addToTable = () => {
    if (selectedItem && id && quantity) {

      const newItem = {
        id: id,
        item_quantity: quantity,
        item_name: selectedItem,
      };

      setList([...list, newItem]);

      setSelectedItem("");
      setQuantity("");
    }
  };

  const removeItem = (index) => {
    const updatedList = [...list];
    updatedList.splice(index, 1);
    setList(updatedList);
  };

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    if (selectedRowData) {
      updateData();
    } else {
      postData();
    }
    setProductName('');
    setCurrentStock('');
    setRate('');
    onClose();
  };

  //search filter
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredItems = allItemsData?.filter(itemservice =>
    itemservice.itemservice.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredCat = categoryData?.filter(category =>
    category.categoryname.toLowerCase().includes(searchTerm.toLowerCase())
  );

  //item stock
  const [itemStock, setItemStock] = useState(0)

  function itemStockFunc(selectedItemTemp) {

    const selItem = allItemsData.filter((item) => item.itemservice === selectedItemTemp)
    setItemStock(selItem[0]?.currentstock)
  }


  return (
    <div className=' max-h-[80vh] overflow-auto' style={{
      display: isOpen ? 'block' : 'none',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      padding: '20px',
      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
      zIndex: '999',
      backdropFilter: 'blur(5px)',
    }}>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <h2 className='text-2xl font-bold font-poppins ml-2 mt-3 mb-3'>{selectedRowData ? "Update Product" : "Add New Product"}</h2>
      <form onSubmit={handleSubmit}>

        <TextField
          type="text"
          variant="outlined"
          color="secondary"
          label="Product Name"
          onChange={(e) => setProductName(e.target.value)}
          value={productName}
          fullWidth
          required
          sx={{ mb: 4 }}
        />

        {!editMode && <>
          <article>

            <FormControl fullWidth>
              <InputLabel id="item">Item & Services Description</InputLabel>
              <Select
                labelId="item"
                id="item"
                value={selectedItem}
                label="Item & Services"
                onChange={(e) => {
                  setSelectedItem(e.target.value)
                  itemStockFunc(e.target.value)
                }}
                sx={{ mb: 4 }}
              >
                <TextField
                  size="small"
                  autoFocus
                  placeholder="Type to search..."
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }}
                  onBlur={() => setSearchTerm('')}
                  onChange={handleSearchChange}
                  onKeyDown={(e) => {
                    if (e.key !== "Escape") {
                      e.stopPropagation();
                    }
                  }}
                  value={searchTerm}
                />
                {filteredItems?.map((itemservice, index) => (
                  <MenuItem key={index} value={itemservice.itemservice}>
                    {itemservice.itemservice}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {categoryData && (
              <FormControl fullWidth>
                <input
                  list="categories"
                  id="category"
                  value={category}
                  onChange={(e) => {
                    const selectedCategory = categoryData.find(item => item.categoryname === e.target.value);
                    setCategory(e.target.value);
                    setCatId(selectedCategory ? selectedCategory.id : null);
                  }}
                  placeholder="Type to search categories..."
                  fullWidth
                  sx={{ mb: 4 }}
                />
                <datalist id="categories">
                  {categoryData?.map((category, index) => (
                    <option key={index} id={category.id} value={category.categoryname}>
                      {`${category.categoryname}`} (ID: {category.id})
                    </option>
                  ))}
                </datalist>
              </FormControl>
            )}

            <div className="md:grid grid-cols-2 gap-10">
              <div className="flex flex-col">
                <label htmlFor="quantity">Quantity</label>
                <input
                  type="number"
                  name="quantity"
                  id="quantity"
                  min="0"
                  placeholder="Quantity"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="item stock">Item Stock</label>
                <input
                  type="number"
                  name="item stocl"
                  id="item stock"
                  min="0"
                  placeholder="Item Stock"
                  value={itemStock}
                  onChange={(e) => setItemStock(e.target.value)}
                  disabled={true}
                />
              </div>
            </div>


          </article>


          {selectedItem.length > 0 && quantity > 0 ? (<button className="w-full flex justify-center text-5xl font-poppins bg-green-800 font-bold text-white" onClick={addToTable}>+</button>) : (null)}
          <table width="100%" className="mb-10 overflow-auto">
            <thead>
              <tr className=" text-center bg-gray-100 p-1">
                <td className="font-bold">Description</td>
                <td className="font-bold">Quantity</td>
                <td className="font-bold">Actions</td>
              </tr>
            </thead>
            {list?.map(({ id, item_name, item_quantity }, index) => (
              <React.Fragment key={id}>
                <tbody>
                  <tr className=" text-center h-10">
                    <td>{item_name}</td>
                    <td>{item_quantity}</td>
                    <td>
                      <button className="text-3xl font-poppins text-red-700" onClick={() => removeItem(index)}>x</button>
                    </td>
                  </tr>
                </tbody>
              </React.Fragment>
            ))}
          </table>
        </>}

        {/* <TextField
          type="number"
          variant="outlined" 
          color="secondary"
          label="Current Stock"
          onChange={(e) => setCurrentStock(e.target.value)}
          value={currentStock}
          fullWidth
          sx={{ mb: 4 }}
          disabled={selectedRowData && employee ? true : false}
        /> */}
        {selectedRowData && employee && (
          <TextField
            type="number"
            variant="outlined"
            color="secondary"
            label="Add Stock"
            onChange={(e) => setAddToStock(e.target.value)}
            value={AddToStock}
            fullWidth
            sx={{ mb: 4 }}
          />
        )}

        {/* <TextField
          type="number"
          variant="outlined"
          color="secondary"
          label="Selling Rate"
          onChange={(e) => setRate(e.target.value)}
          value={rate}
          fullWidth
          required
          sx={{ mb: 4 }}
        /> */}

        {/* uom  */}
        <div className="flex flex-col">
          {uoms.map((uom, index) => (
            <Stack sx={{ mb: 2 }} key={index} spacing={2} direction="row">
              <TextField
                label="UOM"
                value={uom.title}
                onChange={(e) => handleUOMChange(index, 'title', e.target.value)}
                variant="outlined"
                color="secondary"
              />
              <TextField
                label="Quantity"
                value={uom.value}
                onChange={(e) => handleUOMChange(index, 'value', e.target.value)}
                variant="outlined"
                color="secondary"
                type="number"
              />
              <TextField
                label="Selling Price"
                value={uom.price}
                onChange={(e) => handleUOMChange(index, 'price', e.target.value)}
                variant="outlined"
                color="secondary"
                type="number"
              />
              <Button variant="contained" onClick={() => handleRemoveUOM(index)}>Remove</Button>
            </Stack>
          ))}
          <Button sx={{ mb: 5, mt: 1 }} variant="contained" onClick={handleAddUOM}>Add UOM</Button>
        </div>

        <Button
          type="submit"
          variant="contained"
          color="primary"
          size="large"
          sx={{ mb: 2 }}
        >
          {selectedRowData ? "Update Bundled Product" : "Add Bundled Product"}
        </Button>
      </form>
      <Button
        onClick={() => {
          onClose();
          setEditMode(false);
        }}
        variant="outlined"
        color="error"
        size="large"
        sx={{ mb: 2 }}
      >
        Close
      </Button>
    </div>
  );
};

export default NewProductForm;

